import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()}, Data Up.</p>
        <p>Contact: lankfordr51@gmail.com</p>
        <Link to="/privacy" style={{ color: 'inherit' }}>
        {/* ToDo: Add Privacy Policy edits */}
          {/* <span>Privacy</span> */}
        </Link>
      </div>
    </footer>
  );
};

export default Footer; 